/**
 * The one explanation of how a calculated generator status is reached, shared by
 * the facilities list, the generator status tile and the chart header stats.
 * Container tracking is mentioned only to tenants that have it on.
 */
export function calculatedStatusExplanation(containerTrackingEnabled: boolean): string {
  const shipments = "the highest of your e-Manifest, vendor, and reviewed document data.";
  return containerTrackingEnabled
    ? `Each month uses your container tracking data when you have it for that month. Otherwise it uses ${shipments}`
    : `Each month uses ${shipments}`;
}

/** The facilities list column tooltip, as paragraphs: what the column is, then how it is calculated. */
export function calculatedStatusColumnTooltip(
  axis: "federal" | "state",
  containerTrackingEnabled: boolean
): string[] {
  return [
    `The highest calculated ${axis} generator status in any month this calendar year.`,
    calculatedStatusExplanation(containerTrackingEnabled),
  ];
}

/** The shipment chart's header stat is the calculated status every screen shows. */
export function shipmentsStatTooltip(containerTrackingEnabled: boolean): string {
  return `Shows the highest calculated generator status in any month during the time period. ${calculatedStatusExplanation(containerTrackingEnabled)}`;
}

/** @see shipmentsStatTooltip */
export const CONTAINERS_STAT_TOOLTIP =
  "Shows the highest generator status in any month during the time period, calculated from your container fill events.";
